module.exports = __webpack_public_path__ + "img/inapu.0e803146.png";